import {
  getFormValues,
  getUserData,
  setDictionary,
} from 'app/services/businessFunctionHelpers';
import {
  FormsEnum,
  LabelEnum,
  MainOwnerSelectionEnum,
  PersonType,
} from 'app/shared/enums';

export function setMainOwnerSelectionDictionary() {
  const { owner, coowners, mainOwnerSelection } = getFormValues(
    FormsEnum.CalculationForm
  );
  const isOperator = getUserData().user?.operator;

  if (!isOperator) return;

  const getDictValue = (person: PersonType.Owner | PersonType.Coowner1) => {
    const ownerLabel =
      (owner?.name ? `${owner.name} ` : '') +
        (owner?.lastName ? `${owner.lastName}` : '') +
        (owner?.familyName ? `-${owner.familyName}` : '') || LabelEnum.Owner;
    const coowner1Label =
      (coowners?.[1]?.name ? `${coowners[1].name} ` : '') +
        (coowners?.[1]?.lastName ? `${coowners[1].lastName}` : '') +
        (coowners?.[1]?.familyName ? `-${coowners[1].familyName}` : '') ||
      LabelEnum.CoOwner;
    const mainOwnerSelected =
      mainOwnerSelection === MainOwnerSelectionEnum.MainOwner;

    return {
      [PersonType.Owner]: mainOwnerSelected ? ownerLabel : coowner1Label,
      [PersonType.Coowner1]: mainOwnerSelected ? coowner1Label : ownerLabel,
    }[person];
  };

  const dictionary = [
    {
      key: MainOwnerSelectionEnum.MainOwner,
      value: getDictValue(PersonType.Owner),
    },
    {
      key: MainOwnerSelectionEnum.Coowner1,
      value: getDictValue(PersonType.Coowner1),
    },
  ];

  setDictionary({
    dictionaryKey: 'mainOwnerSelection_dictionary',
    dictionary,
    formName: FormsEnum.CalculationForm,
  });
}
